import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "Bildung",
  icon: "🧠",
  templates: [
    {
      title: "Einfach Erklärt",
      content: `Erklären Sie das Thema [wie Impfstoffe das Immunsystem trainieren] auf klare und ansprechende Weise für Zuhörer.
- Stellen Sie sich vor, Sie erklären es [einem neugierigen Teenager ohne naturwissenschaftliche Vorkenntnisse].
- Verwenden Sie eine nachvollziehbare Analogie: [Vergleichen Sie es mit einer Brandschutzübung — man übt für etwas, damit man bereit ist, wenn der Ernstfall eintritt].
- Vermeiden Sie Fachjargon; wenn ein technischer Begriff nötig ist, definieren Sie ihn sofort in einfacher Sprache.
- Schreiben Sie in einem warmen, ermutigenden Ton, der den Zuhörer sich klug fühlen lässt, ohne herablassend zu sein.`
    },
    {
      title: "Dokumentar-Voiceover",
      content: `Schreiben Sie eine Voiceover-Erzählung im Dokumentarstil.
- Thema: [der Alltag der Straßenimbiss-Verkäufer in Bangkok].
- Blickwinkel: [das Handwerk, der Stolz und das generationenübergreifende Wissen hinter Gerichten, die einfach aussehen, aber Jahre dauern, um sie zu meistern].
- Ton: [respektvoll, lebendig und ungehetzt — lassen Sie die Szenen atmen].
- Fügen Sie sensorische Details ein, die dem Zuhörer helfen, die Umgebung zu sehen und zu fühlen: [das Zischen eines Woks, die Feuchtigkeit des Morgenmarkts, die präzisen Handbewegungen eines Verkäufers, der dies zehntausend Mal getan hat].
- Schreiben Sie im Präsens für Unmittelbarkeit.`
    },
    {
      title: "Geführte Meditation",
      content: `Schreiben Sie ein Skript für eine geführte Meditation, das zum Zuhören bestimmt ist.
- Ziel: [Anspannung nach einem langen Arbeitstag lösen und sanft in den Abend gleiten].
- Leiten Sie den Zuhörer an, sich vorzustellen: [ein ruhiges Seeufer bei Sonnenuntergang — warmes Licht auf dem Wasser, eine sanfte Brise, das Geräusch ferner Vögel, die sich für die Nacht niederlassen].
- Ton: [ruhig, ungehetzt und erdend].
- Ungefähre Sprechdauer: [8 Minuten].
- Verwenden Sie reichlich natürliche Pausen (mit "..." markiert) zwischen den Anweisungen. Halten Sie die Sätze kurz und sanft. Vermeiden Sie plötzliche Energiewechsel.`
    }
  ]
};
